import React, { Component } from "react";

export interface ClickableProps {
  isInline?: boolean;
  onHoverChange?: (hasHover: boolean) => void;
  onFocusChange?: (hasFocus: boolean) => void;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
}

interface ClickableState {
  hover: boolean;
  focus: boolean;
}

/**
 * Class that provides a way to detect hover and focus changes in child elements.
 * Should be used sparingly for situations where CSS is not sufficient
 */
export default class Clickable extends Component<ClickableProps, ClickableState> {
  constructor(props: ClickableProps) {
    super(props);

    this.state = {
      hover: false,
      focus: false,
    }

    this.toggleHover = this.toggleHover.bind(this);
    this.toggleFocus = this.toggleFocus.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  toggleHover() {
    const hasHover = !this.state.hover;
    this.setState({
      hover: hasHover
    })

    if (this.props.onHoverChange && !this.props.disabled) {
      this.props.onHoverChange(hasHover);
    }
  }

  toggleFocus() {
    const hasFocus = !this.state.focus;
    this.setState({
      focus: hasFocus
    })

    if (this.props.onFocusChange && !this.props.disabled) {
      this.props.onFocusChange(hasFocus);
    }
  }

  onClick(e: React.MouseEvent) {
    if (this.props.onClick && !this.props.disabled) {
      this.props.onClick(e);
    }
  }

  render() {
    let Wrapper: any = "div";
    if (this.props.isInline) {
      Wrapper = "span";
    }

    return (
      <Wrapper onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover} onFocus={this.toggleFocus} onBlur={this.toggleFocus} onClick={this.onClick}>
        {this.props.children}
      </Wrapper>
    )
  }
}
